import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Folder = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M23 28H9C6.243 28 4 25.757 4 23V9C4 6.243 6.243 4 9 4H12.859C14.534 4 16.09 4.832 17.019 6.226L19.238 9.554C19.424 9.833 19.735 9.999 20.07 9.999H23C25.757 9.999 28 12.242 28 14.999V22.999C28 25.756 25.757 27.999 23 27.999V28ZM9 6C7.346 6 6 7.346 6 9V23C6 24.654 7.346 26 9 26H23C24.654 26 26 24.654 26 23V15C26 13.346 24.654 12 23 12H20.07C19.065 12 18.132 11.501 17.574 10.664L15.355 7.336C14.797 6.499 13.864 6 12.859 6H9V6Z" />
	</svg>
);

export default Folder;
